export default "__VITE_ASSET__DQbviTMj__"